// Übersetzt maschinenlesbare Fehlercodes des Backends in Übersetzungsschlüssel.
//
// Hintergrund: AppError liefert { code, message }, die message ist aber immer
// deutsch. Für die öffentlichen Seiten wird deshalb der Code gemappt und der
// Text aus translations.ts geholt. Unbekannte Codes fallen auf eine generische
// Meldung zurück – so bricht nichts, wenn das Backend neue Codes bekommt.

const ERROR_KEYS: Record<string, string> = {
    // Nominierung & Voting
    PHASE_CLOSED: "ui.err.phaseClosed",
    VOTING_NOT_ACTIVE: "ui.err.votingNotActive",
    CAPTCHA_MISSING: "ui.err.captcha",
    CAPTCHA_FAILED: "ui.err.captcha",
    RATE_LIMITED: "ui.err.rateLimited",
    NOMINATION_BLOCKED: "ui.err.nominationBlocked",
    NOMINATION_LIMIT_REACHED: "ui.err.nominationLimit",
    CATEGORY_NOT_FOUND: "ui.err.categoryNotFound",
    FINALIST_NOT_FOUND: "ui.err.finalistNotFound",

    // Eingabefehler
    EMPTY_TEXT: "ui.err.invalidInput",
    INVALID_INPUT: "ui.err.invalidInput",
    INVALID_NOMINATION: "ui.err.invalidInput",
    VALIDATION_ERROR: "ui.err.invalidInput",

    // Business Case: Fenster
    SUBMISSION_CLOSED: "ui.err.submissionClosed",
    SUBMISSION_NOT_OPEN: "ui.err.submissionNotOpen",

    // Business Case: Uploads
    INVALID_FILE_TYPE: "ui.err.invalidFileType",
    FILE_TOO_LARGE: "ui.err.fileTooLarge",
    TOO_MANY_FILES: "ui.err.tooManyFiles",
    UPLOAD_FAILED: "ui.err.uploadFailed",
    DRIVE_UPLOAD_FAILED: "ui.err.driveUploadFailed",

    // Business Case: Daten
    NO_CASE_REGISTERED: "ui.err.noCaseRegistered",
    NO_CASE_SLOTS: "ui.err.noCaseSlots",
    REGISTRATION_NOT_FOUND: "ui.err.registrationNotFound",
    DRAFT_NOT_FOUND: "ui.err.draftNotFound",
    BUSINESS_CASE_NOT_FOUND: "ui.err.businessCaseNotFound",

    // Technisch
    NETWORK_ERROR: "ui.err.network",
    INTERNAL_ERROR: "ui.err.generic",
};

// Liest den Fehlercode aus einem geworfenen Fehler (apiClient hängt ihn an).
export function apiErrorCode(error: unknown): string | undefined {
    if (error && typeof error === "object" && "code" in error) {
        const code = (error as { code?: unknown }).code;
        if (typeof code === "string") return code;
    }
    return undefined;
}

// Liefert den Übersetzungsschlüssel für einen Fehler.
export function apiErrorKey(error: unknown): string {
    const code = apiErrorCode(error);
    if (code && ERROR_KEYS[code]) return ERROR_KEYS[code];
    return "ui.err.generic";
}